import { MESSAGE_SENDER } from 'consts/enum';
import AudioIcon from 'icons/audioHeadPhone.svg';
import './sendAudio.scss';

const { BOT, AGENT } = MESSAGE_SENDER;

export const SendAudioTemplate = (model) => {
	const { sender, audioUrl, captions, id } = model;

	/* html */
	const trackHTML = captions ? `<track default label="Captions" src="${captions}" kind="captions">` : '';

	/* html */
	const audioHTML = `
		<audio id="engtAudio-${id}" class="engt-audio-msg">
            <source id="src-${id}" src="${audioUrl}" type="audio/mpeg">
            ${trackHTML}
        </audio>
	`;

	/* html */
	const html =
		sender === BOT || sender === AGENT
			? audioHTML
			: `
		<div class="engt-audio-msg-with-indicator">
			<div class="engt-audio-msg-indicator">
				<img src="${AudioIcon}" alt="audio-msg" loader="lazy"/>
				<audio-length></audio-length>
			</div>
			${audioHTML}
		</div>
    `;

	return html;
};
